var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("header", { staticClass: "header" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "span",
            {
              staticClass: "span1",
              on: {
                click: function ($event) {
                  return _vm.handlerAddClick("add")
                },
              },
            },
            [_vm._v("添加机构子账号")]
          ),
          _c(
            "div",
            { staticClass: "btns", on: { click: _vm.handlerBulkImportClick } },
            [_vm._v(" 批量导入 ")]
          ),
          _c(
            "div",
            {
              staticClass: "btns",
              staticStyle: { "margin-left": "16px" },
              on: { click: _vm.approvalConfiguration },
            },
            [_vm._v(" 审批配置 ")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "center" },
          _vm._l(_vm.switchDats, function (item, keys) {
            return _c(
              "p",
              {
                key: keys,
                staticClass: "p1",
                class: _vm.current.name === item.name ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.handlerSwithClick(item)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.name) + " ")]
            )
          }),
          0
        ),
        _c("div", { staticClass: "right" }, [
          _c("input", {
            staticClass: "input1",
            attrs: { placeholder: "输入昵称/手机号", type: "text" },
          }),
          _c("div", { staticStyle: { position: "relative" } }, [
            _c(
              "div",
              {
                staticClass: "btns1",
                on: {
                  click: function ($event) {
                    _vm.flag = !_vm.flag
                  },
                },
              },
              [_vm._v(" 选择 ")]
            ),
            _vm.flag
              ? _c("div", { staticClass: "zhedie" }, [
                  _c(
                    "p",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handlerStateClick(_vm.current.title)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.current.title))]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "container2",
        },
        [
          _c(
            "main",
            { staticClass: "main" },
            _vm._l(_vm.viewDatas, function (item) {
              return _c("div", { key: item.id, staticClass: "mainBox" }, [
                _vm.flag
                  ? _c("div", { staticClass: "selectBtns" }, [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.selectDatas.findIndex(
                              (n) => n.id == item.id
                            ) !== -1
                              ? require("../../assets/png/acitveBtn.png")
                              : require("../../assets/png/nacActive.png"),
                          alt: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selsect(item)
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "btn",
                    class:
                      _vm.current.name === "正常状态" ? "active2" : "active1",
                  },
                  [_vm._v(" 普通用户 ")]
                ),
                _c("div", { staticClass: "left" }, [
                  _c("img", {
                    staticClass: "imgs",
                    staticStyle: { "margin-bottom": "0.12rem" },
                    attrs: {
                      src: item.imageUrl
                        ? item.imageUrl
                        : require("../../assets/png/touxian.jpeg"),
                    },
                  }),
                  _c("span", { staticClass: "span1" }, [
                    _vm._v(_vm._s(item.createTime) + " 生成"),
                  ]),
                ]),
                _c("div", { staticClass: "center" }, [
                  _c("p", [_vm._v(_vm._s(item.userName))]),
                  _c("p", [
                    _vm._v("登录手机：" + _vm._s(item.loginAccount) + " "),
                    _c(
                      "span",
                      {
                        staticClass: "span1",
                        on: {
                          click: function ($event) {
                            return _vm.handlerAddClick("update", item)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "邮箱地址：" +
                        _vm._s(item.email ? item.email : "无") +
                        " "
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "span1",
                        on: {
                          click: function ($event) {
                            return _vm.handlerAddClick("update", item)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]),
                  _c("p", [
                    _vm._v("支付状态：不可用公司账户支付 "),
                    _c(
                      "span",
                      {
                        staticClass: "span1",
                        on: {
                          click: function ($event) {
                            return _vm.handlerAddClick("update", item)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]),
                  _c("p", { staticStyle: { display: "flex" } }, [
                    _vm._v("接单区域： "),
                    item.platSupplierAreas.length > 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "border-bottom": "1px solid #CCCCCC",
                              width: "2.3rem",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap",
                            },
                          },
                          _vm._l(item.platSupplierAreas, function (n, m) {
                            return _c(
                              "span",
                              {
                                key: m,
                                staticClass: "span2",
                                on: {
                                  click: function ($event) {
                                    return _vm.handlerAddClick("update", item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(n.nameCn) + " ")]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticClass: "span1",
                        staticStyle: {
                          "font-size": "20px",
                          "font-weight": "bold",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handlerAddClick("status", item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.status == 1 ? "停用" : "恢复"))]
                    ),
                  ]),
                ]),
              ])
            }),
            0
          ),
          _c(
            "footer",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        color: "gray",
                        "font-size": "0.12rem",
                        "margin-top": "15px",
                      },
                    },
                    [
                      _vm._v(
                        "共" +
                          _vm._s(_vm.total) +
                          "位" +
                          _vm._s(_vm.current.name) +
                          "的员工账号"
                      ),
                    ]
                  ),
                  _c("el-pagination", {
                    attrs: {
                      "page-size": 6,
                      background: "",
                      layout: "prev, pager, next",
                      total: _vm.total,
                    },
                    on: { "current-change": _vm.qhPages },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("addAccount", {
        ref: "addAccount",
        on: { updateStatue: _vm.updateStatue, update: _vm.update },
      }),
      _c("bulkImportPopopVue", { ref: "bulkImportPopopVue" }),
      _c("buIkImportStatePopupVue", {
        ref: "buIkImportStatePopupVue",
        on: { updateStatue: _vm.updateStatue },
      }),
      _c("ApplyProject", { ref: "applyProject" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }